import { TFunction } from 'i18next'
import React from 'react'

const getInfoBoxContent = (
	mode: 'price' | 'consumption' | 'production',
	t: TFunction<'pages_electricity', undefined>
) => (
	<div style={{ padding: '0.6em' }} key='infobox-1'>
		{mode === 'price' ? t('priceInfo') : t('consumptionAndProductionInfo')}
	</div>
)

export default getInfoBoxContent
